
import { ceilNumber, floorNumber, roundNumber } from '@util/numberFormat';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'NumberInput',
})
export default class NumberInput extends Vue {
  $refs!: {
    number: HTMLFormElement
  }

  @Prop() value: number;

  @Prop({ default: 0 }) min: number;

  @Prop({ default: 9999999 }) max: number;

  @Prop({ default: 1 }) decimals: number;

  @Prop({ default: false }) disabled: boolean;

  private editValue: number = null;

  @Watch('value', { immediate: true })
  onValueChanged() {
    this.editValue = this.value || this.value === 0 ? roundNumber(this.value, this.decimals) : null;
  }

  handleChange() {
    if (this.editValue < this.minValue) {
      this.editValue = this.minValue;
    }

    if (this.editValue > this.maxValue) {
      this.editValue = this.maxValue;
    }

    const split = this.editValue.toString().split('.');
    if (Math.floor(this.editValue) !== this.editValue && split.length >= 2 && split[1].length > 1) {
      this.editValue = roundNumber(this.editValue, this.decimals)
    }
  }

  handleBlur() {
    if (this.editValue !== this.value) {
      this.$emit('input', this.editValue);
    }

    this.$emit('blur');
  }

  get step() {
    return Math.pow(10, this.decimals * -1);
  }

  get minValue() {
    return (this.min) ? floorNumber(this.min, this.decimals) : 0;
  }

  get maxValue() {
    return (this.max) ? ceilNumber(this.max, this.decimals) : 9999999;
  }

  public focusField() {
    this.$refs.number.focus();
  }
}
